import("../main");

// educational fairs
import("../../../../land5/js/index").then((_) => {});

// guidances
import("../landings/guidances").then((_) => {});
